/**
 * Segundo fator por e-mail, compartilhado por web e admin.
 *
 * O backend grava na sessao a claim `geo-2fa`. O valor `pending` significa que
 * esta sessao ainda precisa do codigo enviado por e-mail; qualquer outro valor
 * (ou a ausencia da claim, com o 2FA desligado no backend) libera o acesso.
 * Quem decide de verdade e o backend — o front so usa a claim para mandar o
 * usuario a tela certa antes de tomar um 403.
 */
export const SECOND_FACTOR_CLAIM_ID = "geo-2fa";

type AccessTokenPayload = Record<string, unknown> | null | undefined;

export function isSecondFactorPending(payload: AccessTokenPayload): boolean {
  const claim = payload?.[SECOND_FACTOR_CLAIM_ID] as
    | { v?: unknown }
    | undefined;
  return claim?.v === "pending";
}

type ClaimValidationError = { id?: unknown };

/**
 * O backend recusou a requisicao porque a sessao ainda nao passou pelo segundo
 * fator. O SuperTokens responde 403 com `claimValidationErrors` — o mesmo
 * formato da verificacao de e-mail.
 */
export function isSecondFactorRequiredError(error: {
  status?: number;
  data?: unknown;
}): boolean {
  if (
    error.status !== 403 ||
    typeof error.data !== "object" ||
    error.data === null
  ) {
    return false;
  }

  const { claimValidationErrors } = error.data as {
    claimValidationErrors?: unknown;
  };
  return (
    Array.isArray(claimValidationErrors) &&
    claimValidationErrors.some(
      (claim: ClaimValidationError) => claim?.id === SECOND_FACTOR_CLAIM_ID,
    )
  );
}
